import { HttpClient } from '@angular/common/http';
import { Globals } from '../shared/globals';
import { AuthService } from './auth.service';
import { RfidCardData } from '../models/rfidtag.model';
import { Injectable } from '@angular/core';
import { Api } from '../shared/api';

@Injectable()
export class RfidCardsService {
  private url: string;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private globals: Globals,
    private api: Api
  ) {
    this.url = globals.apiUrl('RFIDUserMapping');
  }

  getRfidCards(): Promise<RfidCardData[]> {
    return this.api.httpGet(this.url);
  }

  postRfidCard(rfidCard: RfidCardData) {
    return this.api.httpPost(this.url, rfidCard);
  }

  deleteRfidCard(rfidCard: RfidCardData): Promise<any> {
    const encodedIdentifier = encodeURIComponent(rfidCard.Identifier);
    const url = `${this.url}?identifier=${encodedIdentifier}`;

    return this.api.httpDelete(url);
  }

  /**
   * Import multiple RFID cards.
   */
  async importRfidCards(cards: RfidCardData[]): Promise<RfidCardImportResult> {
    const importUrl = `${this.url}/bulk`;
    const backendResults = await this.api.httpPost<
      RfidCardData[],
      BackendRfidCardImportResult[]
    >(importUrl, cards);

    // Transform backend response to our interface
    const successCount = backendResults.filter((r) => r.Success).length;
    const failures = backendResults
      .filter((r) => !r.Success)
      .map((r) => ({
        card: { Identifier: r.Identifier, Name: r.Name },
        error: r.Error,
      }));

    return { successCount, failures };
  }
}

export interface RfidCardImportResult {
  successCount: number;
  failures: Array<{
    card: RfidCardData;
    error: any;
  }>;
}

interface BackendRfidCardImportResult {
  Identifier: string;
  Name: string;
  Success: boolean;
  Error?: string;
}
